export default __webpack_public_path__ + "static/media/white_mail.1f98df04.svg";